var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 3,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 13,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.5 3h7M1.5 13h7M14.5 3h-3M14.5 13h-3"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 12 0)",
    cx: 6,
    cy: 8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.5 8h-7M1.5 8h3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBar);
export default __webpack_public_path__ + "static/media/filter-bar.cbf29763b03f6767e04b516b101c0c1f.svg";
export { ForwardRef as ReactComponent };